<template>
  <svg
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    width="2292.955"
    height="1231.329"
    viewBox="0 0 2292.955 1231.329"
  >
    <path
      id="Path_204"
      data-name="Path 204"
      d="M2325.764,544.849c-69.293-6.761-72.3-6.366-81.136-6.954-21.245-1.415-65.25-5.265-93.813-7.3-45.085-3.209-89.479-4.291-95.546-4.271-36.727.118-78.549.166-87.839,1.39-12.123,1.6-59.836,4.715-76.193,6.951-27.826,3.8-55.517,8.107-61.389,9.593-22.882,5.793-57.27,14.662-63.7,17.23-23.657,9.446-66.41,26.64-72.782,30.045-12.25,6.544-29.134,15.834-36.877,21.3-19.913,14.047-46.786,33.21-52.729,38.453-6.143,5.42-13.531,12.262-20.492,19.484-11.32,11.743-16.064,17.856-25.891,31.779s-26.215,43.761-29.642,52.24c-6.124,11.654-9.438,23.6-14.067,34.752-2.853,10.968-5.873,20.013-8.438,32.045-1.365,9.716-2.466,16.321-2.832,20.153-1.854,19.416-2.517,24.133-2.3,38.155s1.624,22.07,2.086,28.714c1.013,14.572,2.109,25.439,8.988,48.05s13.572,39.713,20.821,54.085c3.773,7.482,8.767,16.4,14.942,27.461a279.362,279.362,0,0,0,38.244,52.72l63.962,55.217,46.375,28.307,72.529,32.974,71.242,15.808,79.946,4.582,65.244-7.119,55.325-21.246,42.8-30.96,23.265-33.445,12.254-33.341,4.209-29.949-4.149-45.474-14.649-52.043-27.649-55.068-40.307-49.178-40.693-38.172-48.951-29.463L1884.9,772.027,1839.407,758.8l-29.475-4.142-44.911-6.312-52.288,1.173-37.184,3.849-56.106,9.721-87.134,25.757-66.4,27.8-39.6,17.594L1386.4,854l-2.067,1.054-48.224,24.6-40.979,22.193-1.6.865s-39.47,19.761-50.353,25.461c-.722.378-1.459.772-1.893,1.016-5.1,2.875-37.389,17.537-37.389,17.537l-27.311,11.234-22.429,7.876-24.743,8.654-26.078,6.406-39.119,7.59-45.291,5.766-51.375,1.97s-21.583-.418-35.215-.538a152.192,152.192,0,0,1-23.244-1.855l-17.277-2.428s-10.679-1.764-14.719-2.069c-.557.012-20.322-2.546-26.663-3.747-2.844-.4-16.458-2.645-31.375-5.822-19.1-4.97-41.317-10.92-41.317-10.92l-44.582-15.489-30.118-13.281L682.492,930,661.217,918.6l-22.588-14.569S627.188,895.9,615.635,887.2s-23.162-18.326-23.162-18.326-24.141-23.1-33.843-33.8S530.1,798.96,517.7,770.509s-17.95-47.909-17.95-47.909h0c-1.642-4.735-8.76-25.446-10.913-34.448-1.122-4.693-6.015-21.522-9.246-35.4-.019-.082.081.357,0,0-2.973-12.434-4.316-17.573-6.835-27.824-1.01-5.882-1.733-8.651-2.7-14.5-.163-.982-.387-2.414-.627-4.069-.344-2.609.344,2.394-3.533-21.139-2.092-13.225-2.891-23.206-3.564-30.192-1.164-12.067-1.172-13.788-1.6-22.648s-.8-12.611-.8-12.611-1.415-10.859-.474-32.049c0-1.359.187-12.68.628-18.66-.031-8.827,1.53-11.509,2.027-14.42.874-5.033-.5.534,1.267-9.012,1.163-6.3,0-6.362,1.773-12.617.108-.366,3.322-10.47,3.577-11.261,2.046-6.357,5.333-14.946,5.333-14.946s2.386-5.444,2.894-6.946c2.262-6.688,4.891-8.644,10.1-17.527A81.634,81.634,0,0,1,497.25,370.19c5.571-5.438,15.774-11.639,17.078-12.87s8.182-4.186,14.679-5.855c7.239-3.164,12.07-3.394,12.07-3.394s9.534-1.28,18.379-1.944c2.177-.164,23.129.423,31.569,2.74,7.647,1.923,12.321,2.863,20.407,5.7,7.175,3.271,6.971,2.211,13.4,5.279.784.374,7.97,4.205,9.477,5.005,2.921,1.549,4.419,2.683,8.882,5.207a134.576,134.576,0,0,1,16.184,11.606A71.116,71.116,0,0,1,676.6,399.918c1.433,2.135,8.805,12.939,13.434,21.117,1.144,2.021,6.1,16.189,9.619,26.331,1.131,3.259,3.721,15.06,5.027,23.348.433,2.749,1.169,16.86,1.708,27.075.169,3.2-1.4,21.372-2.148,31.68-.191,2.65-2.229,16.3-3.721,26.476-.5,3.411-4.3,15.937-7.273,25.8-1.136,3.765-6.03,17.765-9.209,26.8-.924,2.625-7.42,17.283-11.836,27.182-1.4,3.135-13.4,23.155-21.318,36.285-2.268,3.759-11.848,17.2-19.01,27.154-3.068,4.266-18.52,22.841-26.538,32.439-1.776,2.126-17.5,18.829-27.142,29.048-3.191,3.382-48.809,46.3-67.052,63.45-3.251,3.056-32.61,27.12-46.622,38.582-3.2,2.621-35.088,24.621-48.938,34.158-2.6,1.788-20.857,12.8-30.554,18.631-2.185,1.314-16.5,9.053-25.377,13.84-2.569,1.385-19.395,9.251-28.85,13.657-2.434,1.134-27.259,11.453-41.1,16.762-3.313,1.271-30.679,9.839-44.718,14.358-3,.967-50.9,13.141-74.647,18.069-7.1.96-19.814,3.808-19.814,3.808"
      transform="translate(-187.501 8.417) rotate(-8)"
      fill="none"
      stroke="#ced5cc"
      stroke-width="54.7"
      opacity="0.30"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
svg {
  width: 100%;
  height: auto;
  transform: scale(1.6) translate(13%, 6%);
}

@media (max-width: 1263px) {
  svg {
    transform: scale(1.8) translate(13%, 7%);
  }
}

@media (max-width: 959px) {
  svg {
    transform: scale(2.4) translate(15%, 7%);
  }
}

@media (max-width: 767.98px) {
  svg {
    transform: scale(3.2) translate(19%, 8%);
  }
}

@media (max-width: 599px) {
  svg {
    transform: scale(3.6) translate(23%, 8%);
  }
}

@media (max-width: 350px) {
  svg {
    transform: scale(4.1) translate(23%, 4%);
  }
}

/* Animation */
#Path_204 {
  -webkit-animation: animate-Path_204 5s ease-in forwards;
  animation: animate-Path_204 5s ease-in forwards;
}

@-webkit-keyframes animate-Path_204 {
  from {
    /* stroke-dasharray: 0 4594; */
    stroke-dasharray: 0 5322;
    stroke-dashoffset: 0;
  }

  to {
    /* stroke-dasharray: 4594 0; */
    stroke-dasharray: 5322 0;
    /* stroke-dashoffset: 4594; */
    stroke-dashoffset: 5322;
  }
}

@keyframes animate-Path_204 {
  from {
    stroke-dasharray: 0 5322;
    stroke-dashoffset: 0;
  }

  to {
    stroke-dasharray: 5322 0;
    stroke-dashoffset: 5322;
  }
}
</style>

<style>
</style>